import * as React from 'react';
import { ReactComponent as ExitIconSVG } from '../../assets/icons/mevo/ic_exit.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ExitIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ExitIconSVG} variantPlaces={1} {...props} />;
};

export default ExitIcon;
